// Based on https://www.sitepoint.com/build-javascript-countdown-timer-no-dependencies/
function getTimeRemaining(endtime) {
  var t = Date.parse(endtime) - Date.parse(new Date());
  var seconds = Math.floor((t / 1000) % 60);
  var minutes = Math.floor((t / 1000 / 60) % 60);
  var hours = Math.floor((t / (1000 * 60 * 60)) % 24);
  var days = Math.floor(t / (1000 * 60 * 60 * 24));
  return {
    'total': t,
    'days': days,
    'hours': hours,
    'minutes': minutes,
    'seconds': seconds
  };
}

function initializeClock(selector) {
  var $clock = $(selector);
  if ( $clock.length === 0 ) { return } // clock not present

  // Integer value representing the number of milliseconds since
  // "1 January 1970 00:00:00 UTC", with leap seconds ignored (Unix Epoch; but
  // consider that most Unix time stamp functions count in seconds).
  // You can get this via: Time.parse("2016-12-5 05:00:00 UTC").to_i * 1000
  var dataEpoch = $clock.data('epoch');
  if ( typeof dataEpoch == 'undefined' ) {
    console.error("data-epoch attribute is not defined on " + selector);
    return
  }
  var deadlineEpoch = Number(dataEpoch);
  var deadline = new Date(deadlineEpoch);

  var $days = $clock.find('.days');
  var $hours = $clock.find('.hours');
  var $minutes = $clock.find('.minutes');
  var $seconds = $clock.find('.seconds');

  function zeroPad(num) { return ('0' + num).slice(-2); }

  function updateClock() {
    var t = getTimeRemaining(deadline);

    $days.text(zeroPad(t.days));
    $hours.text(zeroPad(t.hours));
    $minutes.text(zeroPad(t.minutes));
    $seconds.text(zeroPad(t.seconds));

    if ( t.days == 0 && t.hours <= 24) {
      $clock.css('color', 'red');
      $clock.addClass('dc-final-countdown');
    }

    if (t.total <= 0) {
      clearInterval(timeinterval);
    }
  }

  updateClock();
  var timeinterval = setInterval(updateClock, 1000);
}

function warnOnMissingDataAttr($elem, attr) {
  if ( typeof $elem.data(attr) == 'undefined' ) {
    console.error("data-" + attr + " attribute is not defined on " + $elem);
    return
  }
}

$(document).ready(function() {
  initializeClock('.js-promo-counter');
});

// Banner can be dismissed by clicking close, which sets a cookie so we know
// not to show it again.
$(document).on('click', '.js-dismiss-promo-banner', function(e) {
  e.preventDefault();
  var $btn = $(this);
  var cookieName = $btn.data('cookie');
  var expiresEpoch = $btn.data('cookie-expires');
  var expirationTime = new Date(expiresEpoch);
  Cookies.set(cookieName, '1', { expires: expirationTime });
  $($(this).data('target')).hide();
});
